import React from "react";
import EmailForm from "../../components/email-form/email-form";
import Footer from "../../components/footer/footer";
import Header from "../../components/header/header";
import LinkTree from "../../components/link-tree/link-tree";

export default function JoinTheQuantityView() {
    return (
        <>
            <Header></Header>
            <EmailForm></EmailForm>
            <LinkTree></LinkTree>
            <Footer></Footer>
        </>
    )
}